import { limeApiGet } from "./api";
import { AuthContextProps } from "react-oidc-context";

export class FeatureFlagsResult {
    newVgpEnabled: boolean;
    liviVgpEnabled: boolean;
    wearablesEnabled: boolean;
    menopauseEnabled: boolean;

    constructor(
        NewVgpEnabled: boolean = false,
        LiviVgpEnabled: boolean = false,
        WearablesEnabled: boolean = false,
        MenopauseEnabled: boolean = false
    ) {
        this.newVgpEnabled = NewVgpEnabled;
        this.liviVgpEnabled = LiviVgpEnabled;
        this.wearablesEnabled = WearablesEnabled;
        this.menopauseEnabled = MenopauseEnabled;
    }
}

export async function getFeatureFlag(auth: AuthContextProps){
    if (!auth.isLoading && auth.isAuthenticated) {
        return await limeApiGet<FeatureFlagsResult>(`feature`, auth);
    }
    return new FeatureFlagsResult();
}